import { render } from "./ChangeMailButton.vue?vue&type=template&id=7a37af5a&scoped=true"
import script from "./ChangeMailButton.vue?vue&type=script&lang=js"
export * from "./ChangeMailButton.vue?vue&type=script&lang=js"

import "./ChangeMailButton.vue?vue&type=style&index=0&id=7a37af5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a37af5a"]])

export default __exports__